/**
 * Vescify Discord invitation link
 */
export const DiscordInvite = "https://discord.gg/XsRaUk2ev5"

/**
 * Vescify project thread link
 */
export const DiscordThread = "https://discord.com/channels/846794200308908065/1278080689039867935"

/**
 * Github repository link
 */
export const GithubRepository = "https://github.com/Jared-Is-Coding/ESK8CAD.COM"
